import { render, staticRenderFns } from "./create-single.vue?vue&type=template&id=d82133b6&"
import script from "./create-single.vue?vue&type=script&lang=js&"
export * from "./create-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports